import { createContext, useCallback, useContext, useState } from "react";
import { useIsPortrait } from "../hooks/useIsPortrait";
import { isIOS, isMobile, isTablet, isAndroid, isSafari, isDesktop, isEmbedded } from "react-device-detect";
import useWindowSize from "../hooks/useWindowSize";

const verifyTouch = () => {
  try {
    return navigator.maxTouchPoints > 0 && isSafari;
  } catch {}
};

const verifyMobile = () => {
  try {
    return isMobile || isIOS || isSafari && !isDesktop || isAndroid || isEmbedded || isTablet || verifyTouch() || !!(navigator.userAgent || navigator.vendor || window.opera).match(/Mobile DuckDuckGo/);
  } catch (err) {
    return false;
  }
};

export const verifiedIsMobile = verifyMobile();
const verifiedIsIos = isIos();

export const DeviceContext = createContext();

export const useDevice = () => useContext(DeviceContext);

export const DeviceProvider = (props) => {
  const { width } = useWindowSize();
  const isPortrait = useIsPortrait();
  const isMobilePortraitView = isPortrait && verifiedIsMobile;
  const slim = width <= 900 || isMobilePortraitView;

  const [sidebarOpen, setSidebarOpen] = useState(!slim);
  const [compactMode, _setCompactMode] = useState(LocalIsCompactMode());


  const setCompactMode = useCallback((t) => {
    _setCompactMode(cm => {
      let value = typeof t === "function" ? t(cm) : t;
      LocalSetCompactMode(value);
      return value;
    });
  }, [_setCompactMode]);

  return (
    <DeviceContext.Provider
      value={{
        isMobilePortraitView,
        slim,
        isDesktopView: !(isPortrait && verifiedIsMobile),
        isMobilePortrait: isMobile && isPortrait,
        isPortrait: isPortrait,
        isMobile: verifiedIsMobile,
        isIos: verifiedIsIos,
        screenWidth: width,
        sidebarOpen,
        setSidebarOpen,
        compactMode: compactMode && !slim,
        setCompactMode
      }}
    >
      {props.children}
    </DeviceContext.Provider>
  );
};


function isIos() {
  if (isIOS || /iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return navigator.maxTouchPoints > 1 && /MacIntel/.test(navigator.platform);
  }
}


function LocalIsCompactMode() {
  try {
    return localStorage.getItem("assist-compactmode") === "y";
  } catch (err) {
    console.log(err);
    return false;
  }
}

function LocalSetCompactMode(cm) {
  try {
    localStorage.setItem("assist-compactmode", !!cm ? "y" : "n");
  } catch (err) {
    console.log(err);
  }
  return cm;
}
